<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "MEDICAL_APPEAL_DEMOGRAPHICS_TEXT1" | globalTranslate }}
    </h1>
    <hr />

    <div class="appellant-info">
      <p class="static-text case_num">
        <strong
          >{{ "MEDICAL_APPEAL_HOUSEHOLDMEMBER" | globalTranslate }}: </strong
        >{{ householdMember }}
      </p>
      <p class="static-text case_num">
        <strong>{{ "MEDICAL_APPEAL_FILER" | globalTranslate }}: </strong
        >{{
          filer === "Self"
            ? translatedLang === "sp"
              ? "Para mí"
              : ("Self" | globalTranslate)
            : filer
        }}
      </p>
      <p class="static-text">
        <strong>{{ "MEDICAL_APPEAL_DATE" | globalTranslate }}: </strong
        >{{ filingDate }}
      </p>
    </div>
    <br />

    <h2 class="section-header">
      {{ "MEDICAL_APPEAL_MEMBER_ADDRESS" | globalTranslate }}
    </h2>
    <hr />

    <div>
      <!-- address -->
      @if (existingHouseholdMemberAddress && !showHouseholdAddressForm) {
      <div class="appeal_address_info" style="width: -webkit-fill-available">
        <div style="width: -webkit-fill-available" class="col-md-4">
          <div>
            {{ existingHouseholdMemberAddress?.addressLine1 + ", " }}<br />@if
            (existingHouseholdMemberAddress?.addressLine2) {
            <span>{{
              existingHouseholdMemberAddress?.addressLine2 + ", "
            }}</span>
            }
          </div>
          @if (!existingHouseholdMemberAddress?.zip4) {
          <div>
            <div class="row">
              @if (this.addressFormatValue?.code === 'US') {
              <div class="pe-0 city_address_info">
                {{
                  existingHouseholdMemberAddress?.city +
                    ", " +
                    existingHouseholdMemberAddress?.state?.code +
                    " " +
                    householdZip
                }}@if (existingHouseholdMemberAddress?.county) {
                <span>{{
                  ", " + existingHouseholdMemberAddress?.county?.value
                }}</span>
                }
                <span class="pe-0 city_address_info ng-star-inserted">
                  <a
                    class="p-0 pb-1 btn btn-link btn-lg hover-red"
                    (click)="onEdit()"
                  >
                    <span
                      class="pe-2"
                      style="font: normal normal 400 18px 'Open Sans'"
                      tabindex="0"
                      (keydown.enter)="onEdit()"
                      [attr.aria-label]="'EDIT' | globalTranslate"
                      >{{ "EDIT" | globalTranslate }}</span
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 2.5 19.5 19.49"
                    >
                      <g
                        id="_icons_create-outline"
                        data-name=" icons create-outline"
                      >
                        <path
                          id="Combined_Shape-287"
                          data-name="Combined Shape-287"
                          class="cls-1"
                          d="M2.63,19.49A2.62,2.62,0,0,1,0,16.91V5.62A2.63,2.63,0,0,1,2.58,3h7.9a.75.75,0,0,1,.75.75.74.74,0,0,1-.74.75H2.63A1.12,1.12,0,0,0,1.5,5.6V16.87A1.12,1.12,0,0,0,2.61,18H13.88A1.12,1.12,0,0,0,15,16.89V8.24a.76.76,0,0,1,.74-.76.75.75,0,0,1,.76.75v8.64a2.62,2.62,0,0,1-2.59,2.62Zm4.92-7.55a.17.17,0,0,1,0-.18l.39-1.17A.42.42,0,0,1,8,10.41L16.47,2a.43.43,0,0,1,.6,0h0l.47.47a.42.42,0,0,1,0,.59L9.09,11.49a.5.5,0,0,1-.19.1L7.74,12H7.68a.21.21,0,0,1-.13-.05ZM18.17,1.85l-.53-.53a.39.39,0,0,1,0-.53h0l.58-.58a.76.76,0,0,1,1.07,0,.75.75,0,0,1,0,1.06l-.56.57a.4.4,0,0,1-.54,0h0Z"
                        />
                      </g>
                    </svg>
                  </a>
                </span>
              </div>
              } @if (this.addressFormatValue?.code === 'MI') {
              <div class="pe-0 city_address_info">
                {{ existingHouseholdMemberAddress?.addrApoFpo?.value
                }}<span>{{
                  existingHouseholdMemberAddress?.addrAaAeAp?.value +
                    ", " +
                    householdZip
                }}</span>
                <span class="pe-0 city_address_info ng-star-inserted">
                  <a
                    class="p-0 pb-1 btn btn-link btn-lg hover-red"
                    (click)="onEdit()"
                  >
                    <span
                      class="pe-2"
                      style="font: normal normal 400 18px 'Open Sans'"
                      tabindex="0"
                      (keydown.enter)="onEdit()"
                      [attr.aria-label]="'EDIT' | globalTranslate"
                      >{{ "EDIT" | globalTranslate }}</span
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 2.5 19.5 19.49"
                    >
                      <g
                        id="_icons_create-outline"
                        data-name=" icons create-outline"
                      >
                        <path
                          id="Combined_Shape-287"
                          data-name="Combined Shape-287"
                          class="cls-1"
                          d="M2.63,19.49A2.62,2.62,0,0,1,0,16.91V5.62A2.63,2.63,0,0,1,2.58,3h7.9a.75.75,0,0,1,.75.75.74.74,0,0,1-.74.75H2.63A1.12,1.12,0,0,0,1.5,5.6V16.87A1.12,1.12,0,0,0,2.61,18H13.88A1.12,1.12,0,0,0,15,16.89V8.24a.76.76,0,0,1,.74-.76.75.75,0,0,1,.76.75v8.64a2.62,2.62,0,0,1-2.59,2.62Zm4.92-7.55a.17.17,0,0,1,0-.18l.39-1.17A.42.42,0,0,1,8,10.41L16.47,2a.43.43,0,0,1,.6,0h0l.47.47a.42.42,0,0,1,0,.59L9.09,11.49a.5.5,0,0,1-.19.1L7.74,12H7.68a.21.21,0,0,1-.13-.05ZM18.17,1.85l-.53-.53a.39.39,0,0,1,0-.53h0l.58-.58a.76.76,0,0,1,1.07,0,.75.75,0,0,1,0,1.06l-.56.57a.4.4,0,0,1-.54,0h0Z"
                        />
                      </g>
                    </svg>
                  </a>
                </span>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
      <br />

      @if (showHouseholdAddressForm || !existingHouseholdMemberAddress) {
      <div [formGroup]="getControl('data.medAppealAddress')">
        <nh-field
          name="addressFormat"
          label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
          class="label-section"
        >
          <nh-popover
            class="ps-1"
            content="{{ 'CASE_HEAD_POPOVER_TEXT' | globalTranslate }}"
          ></nh-popover>
          <select
            nhTranslate
            name="addressFormat"
            [items]="
              tableCodeValue(
                'ADDRESSFORMATTYPES',
                'data.medAppealAddress.addressFormat'
              )
            "
            [attr.aria-label]="'ADDRESS_FORMAT' | globalTranslate"
            formControlName="addressFormat"
            (change)="addressFormatChange('onChange')"
          ></select>
        </nh-field>
        <nh-name-address
          [addressname]="'appeal-demographics'"
          [addressFormat]="getControl('data.medAppealAddress.addressFormat')"
          [address]="getControl('data.medAppealAddress.address')"
          [stateDefault]="false"
          [isAssistingPerson]="false"
          [addressLine1MaxLength]="46"
          [addressLine2MaxLength]="14"
          [tables]="tables"
          [sectionId]="'MADEM'"
        >
        </nh-name-address>
        <div class="row">
          <div class="col-mr-3 pl-3 pe-3 md-1 py-sm-1">
            <button
              id="continue"
              class="btn d-grid btn-secondary mb-1"
              type="button"
              id="dialog"
              (click)="onSave()"
              [disabled]="!validAddress"
            >
              {{ "SAVE" | globalTranslate }}
            </button>
          </div>
          <div class="col-mr-3 pl-3 pe-3 md-1 py-sm-1">
            <button
              class="btn btn-sm btn-secondary mb-1"
              type="button"
              id="dialog"
              (click)="onCancel()"
            >
              {{ "CANCEL" | globalTranslate }}
            </button>
          </div>
        </div>
      </div>
      }
    </div>
    <br />

    <h2 class="section-header">
      {{ "MEDICAL_APPEAL_MEMBER_INFO" | globalTranslate }}
    </h2>
    <hr />

    <nh-field
      [attr.aria-required]="true"
      label="{{ 'MEDICAL_APPEAL_WRITTEN_LANGUAGE' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="writtenLanguage"
        [items]="tableCodeValue('WRITTENLANGUAGE', 'data.writtenLangCd')"
        [attr.aria-label]="'MEDICAL_APPEAL_WRITTEN_LANGUAGE' | globalTranslate"
        formControlName="writtenLangCd"
        (change)="writtenLang()"
      ></select>
    </nh-field>

    <nh-field
      [attr.aria-required]="true"
      label="{{ 'MEDICAL_APPEAL_SPOKEN_LANGUAGE' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="spokenLanguage"
        [items]="tableCodeValue('SPOKEHEARLANGUAGE', 'data.indvLangPrefCd')"
        [attr.aria-label]="'MEDICAL_APPEAL_SPOKEN_LANGUAGE' | globalTranslate"
        formControlName="indvLangPrefCd"
        (change)="spokenLang()"
      ></select>
    </nh-field>

    @if (getControl('data.indvLangPrefCd').value?.code === 'OT') {
    <nh-field
      [attr.aria-required]="false"
      [mandatory]="false"
      label="{{ 'MEDICAL_APPEAL_LANGUAGE_DETAILS' | globalTranslate }}"
      class="label-section"
    >
      <input
        alphabetic
        type="text"
        name="spokenLanguageDetails"
        class="form-control"
        [attr.aria-label]="'MEDICAL_APPEAL_LANGUAGE_DETAILS' | globalTranslate"
        formControlName="othIndvLangPrefDtls"
        maxlength="30"
      />
    </nh-field>
    }

    <!-- <nh-field label="{{'MEDICAL_APPEAL_INTERPRETER_USED' | globalTranslate }}" class="label-section">
                <select nhTranslate name="interpreterUsed"
                  [items]="tableCodeValue('YESNO', 'data.mbrIntrpretorSw')"
                [attr.aria-label]="'MEDICAL_APPEAL_INTERPRETER_USED' | globalTranslate" formControlName="mbrIntrpretorSw" [hidden]="true"></select>
              </nh-field> -->

    @if (shouldShowInterpreterQuestions()) {
    <nh-field
      [attr.aria-required]="true"
      label="{{ 'MEDICAL_APPEAL_NEED_INTERPRETER' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="needInterpreter"
        [items]="tableCodeValue('YESNO', 'data.mbrNeedIntrpretorSw')"
        [attr.aria-label]="'MEDICAL_APPEAL_NEED_INTERPRETER' | globalTranslate"
        formControlName="mbrNeedIntrpretorSw"
        (change)="needInterpreter()"
      ></select>
    </nh-field>
    } @if (shouldShowInterpreterQuestions() &&
    getControl('data.mbrNeedIntrpretorSw').value?.code === 'Y') {
    <nh-field
      [attr.aria-required]="true"
      label="{{ 'MEDICAL_APPEAL_HEARING_LANGUAGE' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="hearingLanguage"
        [items]="tableCodeValue('SPOKEHEARLANGUAGE', 'data.hearLangPrefCd')"
        [attr.aria-label]="'MEDICAL_APPEAL_HEARING_LANGUAGE' | globalTranslate"
        formControlName="hearLangPrefCd"
        (change)="hearingLang()"
      ></select>
    </nh-field>
    } @if (shouldShowInterpreterQuestions() &&
    (getControl('data.hearLangPrefCd').value?.code === 'OT' &&
    getControl('data.mbrNeedIntrpretorSw').value?.code === 'Y')) {
    <nh-field
      [attr.aria-required]="false"
      [mandatory]="false"
      label="{{ 'MEDICAL_APPEAL_LANGUAGE_DETAILS' | globalTranslate }}"
      class="label-section"
    >
      <input
        alphabetic
        type="text"
        name="hearingLanguageDetails"
        class="form-control"
        [attr.aria-label]="'MEDICAL_APPEAL_LANGUAGE_DETAILS' | globalTranslate"
        formControlName="othHearLangPrefDtls"
        maxlength="30"
      />
    </nh-field>
    }

    <nh-field
      [mandatory]="false"
      [attr.aria-required]="false"
      class="label-section"
      label="{{ 'MEDICAL_APPEAL_EMAIL_ADDRESS' | globalTranslate }}"
      >
      <nh-popover class="ps-1" content="{{'EMAIL_ADDRESS_TOOLTIP' | globalTranslate}}"></nh-popover>
      <input
        type="text"
        name="emailAddress"
        class="form-control"
        [attr.aria-label]="'MEDICAL_APPEAL_EMAIL_ADDRESS' | globalTranslate"
        formControlName="emailAdr"
        maxlength="63"
      />
    </nh-field>

    <div class="row">
      <div class="col">
        <nh-field
          [attr.aria-required]="true"
          label="{{ 'MEDICAL_APPEAL_PRIMARY_PHONE' | globalTranslate }}"
        >
          <input
            type="text"
            name="primaryPhone"
            formControlName="indvPhnNum"
            class="form-control"
            mask="000-000-0000"
            placeholder="XXX-XXX-XXXX"
            [attr.aria-label]="'MEDICAL_APPEAL_PRIMARY_PHONE' | globalTranslate"
          />
        </nh-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <nh-field
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'MEDICAL_APPEAL_EXTENSION' | globalTranslate }}"
        >
          <input
            type="text"
            name="primaryExtension"
            [attr.aria-label]="'MEDICAL_APPEAL_EXTENSION' | globalTranslate"
            formControlName="indvPhnNumExt"
            maxlength="6"
            mask="0*"
            class="form-control"
          />
        </nh-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <nh-field
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'MEDICAL_APPEAL_SECONDARY_PHONE' | globalTranslate }}"
        >
          <input
            type="text"
            name="secondaryPhone"
            formControlName="indvAdtlPhnNum"
            class="form-control"
            mask="000-000-0000"
            placeholder="XXX-XXX-XXXX"
            [attr.aria-label]="
              'MEDICAL_APPEAL_SECONDARY_PHONE' | globalTranslate
            "
          />
        </nh-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <nh-field
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'MEDICAL_APPEAL_EXTENSION' | globalTranslate }}"
        >
          <input
            type="text"
            name="secondaryExtension"
            [attr.aria-label]="'MEDICAL_APPEAL_EXTENSION' | globalTranslate"
            formControlName="indvAdtlPhnNumExt"
            maxlength="6"
            mask="0*"
            class="form-control"
          />
        </nh-field>
      </div>
    </div>

    <nh-field
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'MEDICAL_APPEAL_BEST_TIME_TO_CALL' | globalTranslate }}"
      class="label-section"
      ><select
        nhTranslate
        name="bestTime"
        [items]="tableCodeValue('CONTACTTIME', 'data.contactTimeCd')"
        [attr.aria-label]="'MEDICAL_APPEAL_BEST_TIME_TO_CALL' | globalTranslate"
        formControlName="contactTimeCd"
      ></select>
    </nh-field>
  </section>
</nh-form>